var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingCharacters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.25C12.675 3.25 6.5 8.4825 6.5 16.575C6.5 21.7425 10.4813 27.82 18.4275 34.8075C19.0125 35.3275 20.0038 35.3275 20.5888 34.8075C28.5188 27.82 32.5 21.7425 32.5 16.575C32.5 8.4825 26.325 3.25 19.5 3.25ZM12.4963 20.2962C14.43 18.785 16.8513 17.875 19.5 17.875C22.1487 17.875 24.57 18.785 26.5037 20.2962C25.1062 22.7175 22.5063 24.375 19.5 24.375C16.4937 24.375 13.8938 22.7175 12.4963 20.2962ZM19.5 9.75C21.2875 9.75 22.75 11.2125 22.75 13C22.75 14.7875 21.2875 16.25 19.5 16.25C17.7125 16.25 16.25 14.7875 16.25 13C16.25 11.2125 17.7125 9.75 19.5 9.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingCharacters);
export default __webpack_public_path__ + "static/media/setting-characters.802c142ddce1ece2ef791322e5d123dd.svg";
export { ForwardRef as ReactComponent };